import { styled } from '@mui/material';
import { CoreBox } from '@youscience/core';
import { brightpathTheme } from '@youscience/theme';

export const StyledDivider = styled(CoreBox)(() => ({
  borderRight: `2px solid ${brightpathTheme.palette.grey[400]}`,
}));
